import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, User, ArrowUpRight, ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("luva_token");
    if (t) nav("/admin/dashboard");
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!u || !p) return toast.error("Completá usuario y contraseña");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { username: u, password: p });
      localStorage.setItem("luva_token", data.access_token);
      localStorage.setItem("luva_user", data.username);
      toast.success("¡Bienvenido!");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales inválidas");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-base relative">
      <Link to="/" className="absolute top-6 left-6 inline-flex items-center gap-2 text-mute hover:text-fg text-[13px]">
        <ArrowLeft className="w-4 h-4" /> volver al sitio
      </Link>
      <motion.form
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        onSubmit={submit}
        className="bg-surface border border-line p-8 sm:p-10 w-full max-w-md"
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-brand flex items-center justify-center text-white font-bold text-[15px]" style={{ borderRadius: 2 }}>LU</div>
          <div>
            <div className="text-fg font-semibold text-[18px] leading-none">Panel admin</div>
            <div className="text-mute text-[11px] tracking-wider uppercase mt-1">LUVA Solutions</div>
          </div>
        </div>
        <div className="hairline mt-5" />
        <p className="text-fg-2 text-[14px] mt-5">Ingresá tus credenciales para gestionar contenido, fotos y clientes.</p>
        <div className="mt-6 space-y-4">
          <Field icon={<User className="w-4 h-4" />} label="Usuario" testid={ADMIN.loginUser} value={u} onChange={(e) => setU(e.target.value)} autoComplete="username" />
          <Field icon={<Lock className="w-4 h-4" />} label="Contraseña" testid={ADMIN.loginPw} type="password" value={p} onChange={(e) => setP(e.target.value)} autoComplete="current-password" />
        </div>
        <button data-testid={ADMIN.loginSubmit} type="submit" disabled={loading} className="mt-6 w-full btn-solid py-3 inline-flex items-center justify-center gap-2 text-[14px] rounded-sm disabled:opacity-60">
          {loading ? "Ingresando…" : <>Iniciar sesión <ArrowUpRight className="w-4 h-4" /></>}
        </button>
        <div className="mt-6 text-center text-mute text-[11px]">Credenciales por defecto: admin / admin · cambialas en Seguridad</div>
      </motion.form>
    </div>
  );
}

function Field({ icon, label, testid, ...props }) {
  return (
    <div>
      <label className="block text-mute text-[12px] mb-1.5">{label}</label>
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-mute">{icon}</span>
        <input data-testid={testid} {...props} className="input-base pl-9" />
      </div>
    </div>
  );
}
